/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalFooter, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import ChatService from '../../services/ChatService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import './ClientSubscriptions.css';
import UserNotApproved from './UserNotApproved';
import Message from '../general/Message';
import ErrorBoundary from '../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import SelectedClient from './SelectedClient';
import Loading from '../../assets/UW_Horizontal_Logo_Full.png';
import ClientSubscriptionDetail from './ClientSubscriptionDetail';
import ClientSubscriptionsTable from './ClientSubscriptionsTable';

const ClientSubscriptions = props => {

    // contexts
    const { theme, fontWeight, colors } = useContext(ThemeContext);
    const { user, setUser, selectedTimeZone, userApprovalStatus } = useContext(AuthContext);

    // states
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [activeTab, setActiveTab] = useState("history");
    const [isLoading, setIsLoading] = useState(false);
    const [planCancelled, setPlanCancelled] = useState({
        status: false,
        message: {
            msgBody: '',
            msgError: true
        }
    });

    // useEffects
    useEffect(() => {
        // setIsLoading(true);
        // ProviderService.getClientSubscriptions(pagination.limit, pagination.page, pagination.searchVal, true)
        //     .then(subscriptions => {
        //         console.log('subscriptions', subscriptions);
        //         try {
        //             setSubscriptions(subscriptions.clientSubscriptions);
        //             if (subscriptions.pagination.totalPages <= subscriptions.pagination.page) {
        //                 subscriptions.pagination.page = subscriptions.pagination.totalPages;
        //             }
        //             setPagination(subscriptions.pagination);
        //             setIsLoading(false);
        //         } catch (err) {
        //             setIsLoading(false);
        //             console.log("err", err);
        //             Alert.error("Some error occured, please try again later or report support team.", {
        //                 position: 'top-right',
        //                 effect: 'slide'
        //             });
        //             // GeneralService.logError('at BookSession useEffect2_1', err.stack);
        //         }
        //     });
    }, []);

    // handle functions
    // const handlePagination = (e, index) => {
    //     e.preventDefault();
    //     try {
    //         setPagination({ ...pagination, page: index });
    //     } catch (err) {
    //         Alert.error("Some error occured, please try again later or report support team.", {
    //             position: 'top-right',
    //             effect: 'slide'
    //         });
    //         GeneralService.logError('at Admin Clients handlePagination', 'Error in try catch block', err.stack);
    //     }
    // }

    // const showDetails = (index) => {
    //     try {
    //         props.history.push({
    //             pathname: "/client/clientsubscriptiondetail",
    //             state: {
    //                 subscription: subscriptions[index]
    //             }
    //         });
    //     } catch (err) {
    //         Alert.error("Some error occured, please try again later or report support team.", {
    //             position: 'top-right',
    //             effect: 'slide'
    //         });
    //         GeneralService.logError('at Admin Clients showDetails', 'Error in try catch block', err.stack);
    //     }
    // }

    // function's return
    return (
        <div className='clientSubscription'>
            <ProviderNavbar history={props.history} />
            {
                isLoading ?
                    <img className="mx-auto d-block" height="auto" width="40%" src={Loading} alt="Loading..." />
                    :
                    userApprovalStatus ?
                        <div className='p-3'>
                            {/* Page Heading */}
                            <div>
                                <h1 style={theme.headingBold}>Client Subscriptions</h1>
                                <hr style={{ borderWidth: "2px" }} />
                            </div>
                            <div className='d-flex'>
                                <Nav tabs className='mx-auto'>
                                    <NavItem className={activeTab === "active" ? 'active' : ''} >
                                        <NavLink
                                            onClick={() => setActiveTab("active")}
                                        >
                                            Active
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={activeTab === "history" ? 'active' : ''} >
                                        <NavLink
                                            onClick={() => setActiveTab("history")}
                                        >
                                            History
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </div>
                            <TabContent activeTab={activeTab} className='p-2'>
                                <TabPane tabId="active">
                                    <ClientSubscriptionsTable tabName="active" />
                                </TabPane>
                                <TabPane tabId="history">
                                    <ClientSubscriptionsTable tabName="history" />
                                </TabPane>
                            </TabContent>
                        </div>
                        :
                        <UserNotApproved />
            }
        </div >
    )

}

export default ClientSubscriptions;